import { render, staticRenderFns } from "./trafficPaymentEdit.vue?vue&type=template&id=80c14708&scoped=true&"
import script from "./trafficPaymentEdit.vue?vue&type=script&lang=js&"
export * from "./trafficPaymentEdit.vue?vue&type=script&lang=js&"
import style0 from "./trafficPaymentEdit.vue?vue&type=style&index=0&id=80c14708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c14708",
  null
  
)

export default component.exports